import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../assets/css/Footer.css';
import logo from '../../assets/images/samyama-logo.png';
import iso9001 from '../../assets/images/ISO_9001.png';
import iso27001 from '../../assets/images/layout/ISO_27001.png';
import startupIndia from '../../assets/images/startupindia.png';
import awsPartner from '../../assets/images/aws-partner-logo.png';
import mathLogo from '../../assets/images/math-final-logo.png';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [subscribedEmails, setSubscribedEmails] = useState([]);

  const validateEmail = (email) => {
    // Standard email validation regex
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!email) {
      setMessage('Please enter an email address');
      return;
    }

    if (!validateEmail(email)) {
      setMessage('Please enter a valid email address');
      return;
    }

    // Check if email is already subscribed
    const normalizedEmail = email.toLowerCase();
    if (subscribedEmails.includes(normalizedEmail)) {
      setMessage('You have already subscribed with this email address');
      setIsSubscribed(true);
      setEmail('');
      
      // Reset message after 5 seconds
      setTimeout(() => {
        setMessage('');
        setIsSubscribed(false);
      }, 5000);
      return;
    }

    // Add email to subscribed emails list
    setSubscribedEmails(prev => [...prev, normalizedEmail]);
    
    // Here you would typically send the email to your backend
    // For now, we'll just show a success message
    setMessage('Thank you for subscribing to our newsletter!');
    setIsSubscribed(true);
    setEmail('');
    
    // Reset message after 5 seconds
    setTimeout(() => {
      setMessage('');
      setIsSubscribed(false);
    }, 5000);
  };
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section about">
            <div className="logo-container">
              <img 
                src={logo} 
                alt="Samyama Logo" 
                className="footer-logo"
                width="180"
                height="auto"
              />
            </div>
            {/* <h3>About Samyama</h3>
            <p>
              Samyama is a healthcare technology company focused on clinical trials, bioinformatics, 
              digital health, and imaging solutions. Our mission is to advance healthcare through innovative technology solutions.
            </p> */}
            <div className="social-links">
              <a href="https://www.linkedin.com/company/samyamaa/" target="_blank" rel="noopener noreferrer" className="social-icon linkedin" aria-label="LinkedIn"></a>
              <a href=" https://x.com/Samyama_AI" target="_blank" rel="noopener noreferrer" className="social-icon twitter" aria-label="Twitter"></a>
              <a href="https://www.youtube.com/@samyama-ai" target="_blank" rel="noopener noreferrer" className="social-icon youtube" aria-label="YouTube"></a>
              <a href="https://www.instagram.com/samyamaa.ai/" target="_blank" rel="noopener noreferrer" className="social-icon Instagram" aria-label="Instagram"></a>
              <a href="https://www.facebook.com/samyamaai7" target="_blank" rel="noopener noreferrer" className="social-icon facebook" aria-label="Facebook"></a>
            </div>
          </div>

          <div className="footer-section products">
            <h3>Products</h3>
            <ul className="footer-links">
              <li><Link to="/products/bimigrator">BI Migrator</Link></li>
              <li><Link to="/products/devops-buddy">DevOps Buddy</Link></li>
              <li><Link to="/products/csdlc">CSDLC</Link></li>
              <li><Link to="/products/csdlc-ai">CSDLC AI</Link></li>
              <li><Link to="/products/hcdlc-ai">HCDLC AI</Link></li>
              <li><Link to="/products/rapid-medi-capture">Rapid MediCapture EDC</Link></li>
              <li><Link to="/products/aisdlc">AISDLC</Link></li>
            </ul>
          </div>

          <div className="footer-section contact">
            <h3>Contact Us</h3>
            <address>
              <div className="contact-info">
                <a 
                  href="mailto:enquiry@samyama.ai" 
                  className="icon-link"
                >
                  <i className="fas fa-envelope contact-icon"></i>
                </a>
                <a href="mailto:enquiry@samyama.ai"
                className="text-link">
                enquiry@samyama.ai
                </a>
              </div>
              <div className="contact-info">
                <a 
                  href="tel:+919618986039" 
                  className="icon-link"
                >
                  <i className="fas fa-phone-alt contact-icon"></i>
                </a>
                <a 
                  href="tel:+919618986039"
                  className="text-link"
                >
                  +91 9618986039
                </a>
              </div>
              <div className="contact-info">
                <a 
                  href="https://www.google.com/maps/place/VaidhyaMegha+Private+Limited/@17.360415,78.424643,17z/data=!4m6!3m5!1s0x3bcb979cc300bdeb:0x1ce3b32213e4b0fb!8m2!3d17.3604147!4d78.4246427!16s%2Fg%2F11h229czhv?entry=tts" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="icon-link"
                >
                  <i className="fas fa-map-marker-alt contact-icon"></i>
                </a>
                <div>
                  <a 
                    href="https://www.google.com/maps/place/VaidhyaMegha+Private+Limited/@17.360415,78.424643,17z/data=!4m6!3m5!1s0x3bcb979cc300bdeb:0x1ce3b32213e4b0fb!8m2!3d17.3604147!4d78.4246427!16s%2Fg%2F11h229czhv?entry=tts" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="address-link"
                  >
                    <span className="address-label">Registered Office:</span>
                    <span className="address-line">C/o VaidhyaMegha Pvt. Ltd.</span>
                    <span className="address-line">3-5-139/3/3/2, Shiva Nagar Colony,</span>
                    <span className="address-line">Attapur, Hyderguda, Hyderabad,</span>
                    <span className="address-line">Telangana 500048, India</span>
                  </a>
                </div>
              </div>
            </address>
            <div className="newsletter">
            <h4>Subscribe to our Newsletter</h4>
              <form className="newsletter-form" onSubmit={handleSubmit}>
                <input 
                  type="email" 
                  placeholder="Your email address" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isSubscribed}
                />
                <button 
                  type="submit" 
                  className="btn-subscribe"
                  disabled={isSubscribed}
                >
                  {isSubscribed ? 'Subscribed!' : 'Subscribe'}
                </button>
                
              </form>
              {message && (
                <div className={`newsletter-message ${isSubscribed ? 'success' : 'error'}`}>
                  {message}
                </div>
                
              )}
            </div>
          </div>
        </div>

        {/* Certifications and Partners Section */}
        <div className="certifications-partners">
          <div className="certifications">
            <h4>Certifications</h4>
            <div className="certification-logos">
              <div className="certification-logo">
                <img src={iso27001} alt="ISO 27001:2022 Certified" />
              </div>

              <div className="certification-logo">
                <img src={iso9001} alt="ISO 9001:2015 Certified" />
              </div>
              <a 
                href="https://recognition-be.startupindia.gov.in/s3/download/document/RECOGNITION_CERTIFICATE/abac5f9b-de36-4740-98d9-d36d27e02520.pdf" 
                target="_blank" 
                rel="noopener noreferrer"
                className="certification-logo"
              >
                <img 
                  src={startupIndia} 
                  alt="Startup India Recognized" 
                  className="startup-india-logo"
                />
              </a>
            </div>
          </div>
          
          <div className="vertical-divider"></div>
          
          <div className="partners">
            <h4>Partners</h4>
            <div className="partner-logos">
              <div className="partner-logo">
                <img src={awsPartner} alt="AWS Partner Network" />
              </div>
              <div className="partner-logo">
                <img src={mathLogo} alt="MATH - Driving AI Evolution" />
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="copyright">
            <p>&copy; 2018 – {new Date().getFullYear()} VaidhyaMegha Pvt. Ltd., now innovating as Samyama. All Rights Reserved.</p>
          </div>
          <div className="legal-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-and-conditions">Terms & Conditions</Link>
            <Link to="/refund-and-cancellation-policy">Refund Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;